<script>
  import Picture from "../Picture.svelte";

  import DashboardTitle from "./DashboardTitle.svelte";

  import { post } from "../../js/labit-connection";

  import { onMount } from "svelte";

  let birthdays = [];

  onMount(async () => {
    const bdate = "%-" + moment().format("MM") + "-" + moment().format("DD");
    const response = await post(
      `select p.Name, p.PictureUrl, lastActivity, profileStatus, atHome
        from people as p
        left join companies as c on c.company_id=p.company_id
        where BirthDate like '${bdate}' and c.Name='Labit Group' and p.active=1`
    );
    birthdays = response.map((item) => {
      return {
        name: item.Name,
        pic: item.PictureUrl,
        lastActivity: item.lastActivity,
        profileStatus: item.profileStatus,
        atHome: item.atHome,
      };
    });
  });
</script>

<div class="dashboardContainer">
  <DashboardTitle title="Birthdays" numEvents={birthdays.length} />
  <div class="dashboardBody">
    <div class="birthdays">
      {#each birthdays as birthday}
        <div class="birthday">
          <Picture
            image={birthday.pic}
            name={birthday.name}
            showHint={true}
            lastActivity={birthday.lastActivity}
            officeStatus={birthday.officeStatus}
            atHome={birthdays.atHome}
          />
        </div>
      {/each}
    </div>
  </div>
</div>

<style>
  div.dashboardContainer {
    width: 100%;
    height: 100%;
  }

  div.dashboardBody {
    width: 100%;
    height: 85%;
    padding: 5%;
  }

  div.birthdays {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }

  div.birthday {
    height: 57px;
    width: 57px;
    margin: 0px 5px 10px 5px;
  }
</style>
